<!-- 直播活动更多 -->
<template>
  <div>
    <div class="app-content mt10 mb10">
      <div class="top new-top blue-text">
        <!-- <img src="@/assets/images/直播.png" alt="" class="icon-zhibo">
        <span class="fs20 ml5">直播活动</span> -->
      </div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="(item, index) in tabList"
          :key="index"
          :name="item.state"
        >
          <span slot="label">
            <img v-if="item.state + '' === '2'" src="@/assets/images/直播.png" alt="" class="icon-zhibo">
            <span class="fs20 ml5">{{ item.title }}</span>
          </span>
          <div v-if="item.list && item.list.length > 0">
            <div  class="div-all">
              <!-- <div
                v-for="(itemItem, indexItem) in item.list"
                :key="indexItem"
                class="tab-div"
              >
                <img :src="prodUrl+itemItem.imageUrl" alt="" class="hand-cursor" @click="onClick(itemItem)"/>
                <div class="detail-text">
                  <p class="text-title ellipsis-one" :title="itemItem.title">{{itemItem.title}}</p>
                  <div class="detail-content">
                    <p>培训讲师: {{itemItem.trainingInstructors}}</p>
                    <p>讲师单位: {{itemItem.lecturerUnit}}</p>
                    <p>课程分类: {{ transFormEnum(labelList, itemItem.courseClassification) }}</p>
                    <p>课程来源: {{itemItem.courseSource}}</p>
                  </div>
                  <div class="mt10 fw700">
                    <span class="blue-text">直播倒计时：</span>
                    <span class="red" v-if="itemItem.state === 1 && itemItem.deadline === 0">
                      {{ computedTime(itemItem.beginDate) }}
                    </span>
                    <span v-else>
                      <span class="red">{{ itemItem.deadline }}天</span>
                    </span>
                  </div>
                </div>
                <div class="iv-tips" :class="itemItem.state + '' === '1' ? 'jijiangzhibo' : (itemItem.state + '' === '2' ? 'zhibozhong' : 'zhibojieshu')">{{itemItem.stateName}}</div>
              </div> -->
              <div 
                class="detail-box hand-cursor gs-card" 
                v-for="(item,i) in item.list" 
                :key="i"
                @click="onClick(item)"
              >
                <img :src="prodUrl+item.imageUrl" alt="" class="hand-cursor"/>
                <div class="detail-text">
                  <div>
                    <div class="mb5 fw700">
                      <img src="@/assets/images/shijian-25 2@2x.png" alt="" class="hand-cursor icon-tips mr5"/>
                      <span class="blue-text time-text-style">{{item.state === 1 ? '直播倒计时' : (item.state === 2 ? '正在直播中' : '直播已结束')}}</span>
                      <span v-if="item.state === 1" class="red time-text ml5">
                        <span v-if="item.deadline && item.deadline > 1">
                          {{ item.deadline }}天
                        </span>
                        <span v-else>
                          {{ computedTime(item.beginDate) }}
                        </span>
                      </span>
                      <span v-if="item.state === 3" class="red time-text ml5 gray">00:00:00</span>
                    </div>
                  </div>
                  <div class="text-title ellipsis-one" :title="item.title">{{item.title}}</div>
                  <div class="detail-content">
                    <p class="ellipsis-one" :title="item.trainingInstructors">培训讲师: {{item.trainingInstructors}}</p>
                    <p class="ellipsis-one" :title="item.lecturerUnit">讲师单位: {{item.lecturerUnit}}</p>
                    <p class="ellipsis-one">课程分类: {{ transFormEnum(labelList, item.courseClassification) }}</p>
                    <p class="ellipsis-one" :title="item.courseSource">课程来源: {{item.courseSource}}</p>
                  </div>
                </div>
                <div class="iv-tips" :class="item.state === 1 ? 'jijiangzhibo' : (item.state === 2 ? 'zhibozhong' : 'zhibojieshu')">
                  <img v-if="item.state === 1" src="@/assets/images/yuyue-2 2@2x.png" alt="" class="hand-cursor icon-tips mr5"/>
                  <img v-if="item.state === 2" src="@/assets/images/形状@2x.png" alt="" class="hand-cursor icon-tips mr5"/>
                  <img v-if="item.state === 3" src="@/assets/images/zhibohuifang@2x.png" alt="" class="hand-cursor icon-tips mr5"/>
                  {{item.stateName}}
                </div>
              </div>
            </div>
            <div class="table-pagination">
              <GsPagination
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
          <div v-else>
            <NoData />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import NoData from '@/components/NoData/index.vue'
import { getLiveList } from "@/api/api";
import {enumType} from '@/utils/enum.js'
import { getDataType } from '@/api/Layout/index.js'
import GsPagination from '@/components/GsPagination/index.vue'
export default {
  name: 'LiveInfoMore',
  components: { NoData, GsPagination },
  data() {
    return {
      loading: false,
      title: (this.$route.meta && this.$route.meta.title) || '',
      prodUrl:"https://shujuzichan.com/xwzx",
      activeName: '2',
      labelList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      countdownTimer: null, // 新增：倒计时定时器
      tabList: [
        {
          title: '直播观看',
          state: '2',
          list: []
        },
        {
          title: '预定直播',
          state: '1',
          list: []
        },
        {
          title: '直播回放',
          state: '3',
          list: []
        }
      ]
    }
  },
  computed: {
    transFormEnum () {
      return function (enumList, value, multi) {
        if(value) {
          let valObj = []
          if(multi) {
            valObj = JSON.parse(value)
          } else {
            valObj = value.split(',').map(item => item.trim())
          }
          let labelListEnum = []
          if(enumList && enumList.length > 0) {
            enumList.forEach(item => {
              valObj && valObj.forEach(itemObj => {
                if(itemObj === item.value) {
                  labelListEnum.push(item.label)
                }
              })
            })
          }
          return labelListEnum.join(',')
        } else {
          return ''
        }
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.startCountdownTimer(); // 启动倒计时刷新
  },
  beforeDestroy() {
    clearInterval(this.countdownTimer); // 清理倒计时定时器
  },
  created() {
    let params = {
      name: '2'
    }
    this.handleClick(params)
    this.getData('sys_live_course_classification')
  },
  methods: {
    // 新增：启动倒计时定时器
    startCountdownTimer() {
      this.countdownTimer = setInterval(() => {
        // 强制组件重新渲染，更新倒计时显示
        this.$forceUpdate();
      }, 1000); // 每秒更新一次
    },
    computedTime(beginDate) {
      if (!beginDate) return '--:--:--';
      
      // 将开始时间转换为Date对象
      const targetTime = new Date(beginDate).getTime();
      const now = new Date().getTime();
      
      // 计算时间差（毫秒）
      const diff = targetTime - now;
      
      if (diff <= 0) {
        // 如果时间已过，显示00:00:00
        return '00:00:00';
      }
      
      // 计算时、分、秒
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      // 格式化为两位数
      const formatHours = hours.toString().padStart(2, '0');
      const formatMinutes = minutes.toString().padStart(2, '0');
      const formatSeconds = seconds.toString().padStart(2, '0');
      
      return `${formatHours}:${formatMinutes}:${formatSeconds}`;
    },
    onClick(item) {
      window.open(item.url, "_blank");
    },
    async getData(type) {
      try {
        const res = await getDataType(type);
        if (res && res.data && res.data.length > 0) {
          if(type === 'sys_live_course_classification') {
            this.labelList = enumType(res.data)
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    },
    handleClick(tab, event) {
      console.log('val--1', tab.name, event)
      if(tab.name) {
        this.getLiveList(tab.name, this.currentPage, this.pageSize)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getLiveList(this.activeName, this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getLiveList(this.activeName, this.currentPage, this.pageSize)
    },
    getLiveList (val, currentPage, pageSize) {
      var formData = {};
      formData["pageNum"]=currentPage;
      formData["pageSize"]=pageSize;
      formData["state"] = val
      getLiveList(formData).then((response) => {
        this.tabList = this.tabList.map(itemMap => {
          if(itemMap.state === val) {
            itemMap.list = response.rows
          }
          return itemMap
        })
        this.total = response.total
      })
    },
  }
}
</script>
<style lang="css" scoped>
.div-all {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* gap: 10px; 可选，设置项目之间的间距 */
}
.tab-div {
  flex: 0 0 calc(25% - 10px); /* 每行4个，减去间隙 */
  margin-bottom: 10px; /* 可选，行与行之间的间距 */
  position: relative;
  img{
    width: 100%;
    height: 130px;
    /* width: 100%; */
  }
  .detail-text {
    padding: 10px;
  }
  .text-title {
    font-size: 15px;
    /* font-weight: 700; */
  }
}
.detail-content{
  color: #999999;
  margin-top: 5px;
  line-height: 22px;
}
.iv-tips{
  padding: 0 10px;
  border-radius: 20px;
  font-size: 8px;
  background-color: #ff0000;
  color:#fff;
  position: absolute;
  top: 5px;
  right: 10px;
  font-weight: 600;
}
.jijiangzhibo {
  background-color: rgb(236, 222, 75);
  color: #0165FF;;
}
.zhibozhong {
  background: rgb(236, 222, 75);
  color: #ff0000;
}
.new-top {
  margin-left: 10px;
}
.icon-zb {
  width: 60px;
  height: 42px;
}
.top {
  font-weight: 700;
  margin-bottom: 15px;
}
.hot-center-left img {
  width: 100%;
  height: 100%;
}
.more:hover {
  color:red;
}
.time-text {
  height: 20px;
  font-family: DINCondensed, DINCondensed;
  font-weight: bold;
  font-size: 20px;
  color: #0165FF;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}
.gray {
  height: 20px;
  font-family: DINCondensed, DINCondensed;
  font-weight: bold;
  font-size: 20px;
  color: #7E8288;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}
.time-text-style {
  height: 20px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #111824;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.icon-tips {
  width: 12px !important;
  height: 12px !important;
}
/* 轮播容器样式 */
.hot-bottom-container {
  position: relative;
  width: 100%;
  /* margin: 0 10px; */
  display: flex;
  align-items: center;
}

.hot-bottom {
  width: 100%;
  display: flex;
  overflow: hidden;
  scroll-behavior: smooth;
  justify-content: flex-start;
}

/* 轮播按钮样式 */
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  color: #0165FF;
  font-size: 18px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.carousel-btn:hover {
  background: #0165FF;
  color: white;
}

.prev-btn {
  left: -20px;
}

.next-btn {
  right: 5px;
}

.detail-box {
  flex: 0 0 calc(25% - 12px); /* 每行4个，减去间隙 */
  margin-right: 10px;
  position: relative;
  transition: transform 0.3s;
  height: 270px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

div.detail-box:last-child {
  margin-right: 0 !important;
}

.detail-box img {
  width: 100%;
  height: 130px;
  border-radius: 15px 0 0 0;
}

.detail-text {
  top: 100px;
  margin: 0 10px;
  height: 130px;
  background: #FFFFFF;
  border-radius: 8px;
  position: absolute;
  width: 80%;
  padding: 16px;

}

.text-title {
  width: 100%;
  height: 32px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 20px;
  color: #111824;
  line-height: 32px;
  text-align: left;
  font-style: normal;
}

.detail-content{
  /* height: 80px; */
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 12px;
  color: #111824;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.iv-tips{
  position: absolute;
  top: 0px;
  left: 0;
  font-weight: 600;
  width: 80px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 17px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 12px;
  color: #FFFFFF;
  padding: 5px;
  border-radius: 15px 0;
  background: #54637A ;
}

.jijiangzhibo {
  background-color: #5FDC00;
}

.zhibozhong {
  /* background: rgb(236, 222, 75);
  color: #ff0000; */
  background-color: #0165FF;
}

.new-top {
  /* margin-left: 10px; */
  background-image: url('@/assets/images/矩形@2x.png');
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

/* 响应式调整 */
/* @media (max-width: 1200px) {
  .detail-box {
    flex: 0 0 calc(33.333% - 10px);
  }
} */

@media (max-width: 768px) {
  /* .detail-box {
    flex: 0 0 calc(50% - 10px);
  } */
  
  .carousel-btn {
    width: 30px;
    height: 30px;
    font-size: 14px;
  }
  
  .prev-btn {
    left: -15px;
  }
  
  .next-btn {
    right: -35px;
  }
}
.detail-box:hover {
  border: 1px solid #f00;
  border-radius: 15px 0 0 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
</style>